import TopNavigation from "@amzn/awsui-components-react/polaris/top-navigation";
import { TopNavigationProps } from "@amzn/awsui-components-react/polaris/top-navigation/interfaces";
import { HOME_PAGE_URL } from "../module/AuthAdminModule";
import {currentApiDomain, REQUEST_INIT} from "../util/helperUtil";
import locales from "../localization/locales.json"
import i18n from "i18next";
import {getSupportedLanguageOptions, setLanguage} from "../localization/LocalizationModule";
import {useTranslator} from "../localization/Translator";

interface HeaderLayoutProps {
  userId?: string;
}

interface DropdownEvent {
  detail: {
    id: string;
    [key: string]: any;  // Allows for any additional properties in detail
  };
  [key: string]: any;  // Allows for any additional properties in the event object
}


const HeaderLayout = (props: HeaderLayoutProps) => {
  const t = useTranslator();
  const signOutText = t.translate("auth_admin_portal_sign_out_text");
  const redirectToLogout = () => {
    fetch(currentApiDomain + '/Logout', {
      method: 'GET', ...REQUEST_INIT, headers: {
        Accept: 'application/json', 'Content-Type': 'application/json'
      }
    }).then(response => response.json()).then(function (res) {
      window.location.replace(window.origin + "/logout");
    });
  }
  const userProfileDropDown: TopNavigationProps.Utility = {
    type: "menu-dropdown",
    text: props.userId,
    iconName: "user-profile",
    items: [{ id: "signout", text: signOutText }],
    onItemClick: redirectToLogout
  };
  const localeDropdown : TopNavigationProps.Utility = {
    type: "menu-dropdown",
    // @ts-ignore
    text: locales.supportedLocales[i18n.language].langName,
    items: getSupportedLanguageOptions(),
    // @ts-ignore
    iconName: "flag",
    onItemClick: (event: DropdownEvent) => setLanguage(event.detail.id)
  }

  return (
    <TopNavigation
      id="h"
      identity={{
        href: HOME_PAGE_URL,
        title: t.translate("auth_admin_portal_title"),
      }}
      utilities={[localeDropdown, userProfileDropDown]}
    />
  );
};
export default HeaderLayout;
